export default __webpack_public_path__ + "static/media/icon1.ab31a11b.svg";